<template>
  <div class="fondo-gato">
    <section class="jugadores">
      <h1>🎮 Reglas del Juego del Gato Volador</h1>
      <ul>
        <li>😺 Tienes <strong>3 vidas</strong>.</li>
        <li>🐶 ¡Sobrevive a los perros el mayor tiempo posible!</li>
        <li>💥 Cada enemigo derrotado te da <strong>+0.6s</strong>.</li>
        <li>👹 ¡El boss es monstruoso! Evítalo.</li>
        <li>🧠 Al morir, tu puntaje se guarda automáticamente.</li>
      </ul>

      <div class="puntajes">
        <p>
          <strong>📍 Tu mejor puntaje registrado:</strong>
          {{ mejorJugadorScore }} pts
        </p>
        <p><strong>🕓 Últimos intentos:</strong></p>
        <ul class="historial">
          <li v-for="(j, i) in historial" :key="i">
            {{ j.fecha }} → {{ j.puntaje }} pts ({{ j.duracion }}s)
          </li>
        </ul>
      </div>

      <div class="ranking-global">
        <h2>🌍 Top Global</h2>
        <ol>
          <li v-for="(jugador, index) in topGlobal" :key="index">
            <span class="icon">
              <i
                v-if="index === 0"
                class="mdi mdi-trophy"
                style="color: gold"
              ></i>
              <i
                v-else-if="index === 1"
                class="mdi mdi-trophy"
                style="color: silver"
              ></i>
              <i
                v-else-if="index === 2"
                class="mdi mdi-trophy"
                style="color: peru"
              ></i>
              <span v-else>#{{ index + 1 }}</span>
            </span>
            {{ jugador.nombre }} — {{ jugador.puntos }} pts
          </li>
        </ol>
      </div>

      <button @click="jugar" class="btn-jugar">¡Jugar ahora!</button>
    </section>
  </div>
</template>

<script>
import HttpService from "@/Servicios/HttpService";
export default {
  data() {
    return {
      mejorScore: 0,
      historial: [],
      topGlobal: [],
      mejorJugadorScore: 0, // 🆕
    };
  },
  mounted() {
    this.obtenerTopGlobal();
    this.obtenerMejorJugadorScore(); // 🆕

    const local = JSON.parse(localStorage.getItem("historialJuego")) || [];
    this.historial = local.slice(-5).reverse();
    this.mejorScore = Math.max(...local.map((e) => e.puntaje || 0), 0);
  },

  methods: {
    async obtenerTopGlobal() {
      try {
        const res = await HttpService.obtenerConConsultas("juego.php", {
          accion: "obtener_top",
        });
        if (res.ok) this.topGlobal = res.datos;
      } catch (e) {
        console.warn("No se pudo cargar el top global", e);
      }
    },
    async obtenerMejorJugadorScore() {
      const idJugador = localStorage.getItem("idUsuario");
      if (!idJugador) return;

      try {
        const res = await HttpService.obtenerConConsultas("juego.php", {
          accion: "mejor_jugador",
          idJugador,
        });
        if (res.ok) this.mejorJugadorScore = res.mejor || 0;
      } catch (e) {
        console.warn("No se pudo obtener el puntaje del jugador", e);
      }
    },
    jugar() {
      const aviso = document.createElement("div");
      aviso.innerText = "Por favor gira tu celular a modo horizontal 📱↔️";
      Object.assign(aviso.style, {
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        background: "#000",
        color: "#fff",
        padding: "1rem",
        fontFamily: "'Press Start 2P'",
        zIndex: 99999,
      });
      document.body.appendChild(aviso);

      setTimeout(() => {
        aviso.remove();
        window.location.href =
          "/JuegoGato/index.html";
      }, 2000);
    },
  },
};
</script>

<style scoped>
.fondo-gato {
  background-image: url("https://megapos.co/fotos/6857c48c7cf83.webp");
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  min-height: 100vh;
  padding-top: 30px;
  display: flex;
  justify-content: center;
align-items: flex-start;
}

.jugadores {
  backdrop-filter: blur(8px);
  background: rgba(0, 0, 0, 0.45);
  border-radius: 12px;
  padding: 2.5rem;
  color: white;
  font-family: 'Press Start 2P', monospace;
  font-size: 18px;
  max-width: 700px;
  width: 90%;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
}

/* Márgenes para separar visualmente */
.jugadores h1 {
  margin-bottom: 2rem;
}

.jugadores ul {
  margin-bottom: 2.5rem;
}

.puntajes {
  margin-bottom: 3rem;
}

.ranking-global {
  margin-bottom: 3rem;
}

.btn-jugar {
  margin-top: 2.5rem;
  background: #10b981;
  border: none;
  color: white;
  padding: 1.2rem 2rem;
  font-size: 1.1rem;
  cursor: pointer;
  font-family: inherit;
  display: block;
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  box-shadow: 0 0 12px #10b981;
}

/* Forzar strong a blanco */
.jugadores strong {
  color: white;
}

.icon {
  display: inline-block;
  width: 2rem;
}

/* Responsive */
@media (max-width: 600px) {
  .jugadores {
    padding: 1.5rem;
    font-size: 14px;
  }

  .btn-jugar {
    font-size: 0.95rem;
    padding: 0.75rem 1rem;
  }
}

</style>
